<template>
  <div class="investment-card bg--color-02 bor--radius-10 sha--03">
    <div class="investment-card__container">
      <div
        class="investment-card__top flx flx--col pt-26 pt-16--l pl-14 pl-24--l pr-14 pr-24--l pb-12--l"
      >
        <div class="investment-card__title-with-status flx flx--col">
          <div class="investment-card__status-block flx flx--items-center mb-4">
            <div
              class="investment-card__status-dot"
              :class="`bg--${status.color}`"
            />
            <span
              class="investment-card__status-name txt--bold txt--14px txt--height-18px ml-6 ml-4--l"
              :class="`txt--${status.color}`"
            >
              {{ status.text }}
            </span>
          </div>
          <span
            class="txt--bold txt--color-04 txt--22px txt--26px--l txt--height-30px txt--height-34px--l"
          >
            {{ investment.ticker }},
            {{ getCurrencyFullName(investment.ticker) }}
          </span>
        </div>
        <div class="investment-card__hand-with-logo">
          <img
            class="investment-card__logo"
            :src="
              investment.logo || require('@/assets/icons/ieo/default-coin.svg')
            "
            alt="investment icon"
          >
        </div>
      </div>

      <div
        class="investment-card__bottom bg--color-01 pt-14 pb-14 pl-18 pr-18 p-24--l"
      >
        <investment-card-info-numbers
          :investment="investment"
          class="investment-card__numbers mb-24--ml"
        />

        <div class="investment-card__buttons">
          <div class="investment-card__buttons-container">
            <exc-button
              size="s"
              full-width
              :to="cardLink"
              class="investment-card__stating-button"
            >
              {{ $t('staking.deposit.button') }}
            </exc-button>

            <exc-dropdown
              class="investment-card__dropdown"
              :options="investment.dropdownOptions"
              size="s"
            >
              <template #selected>
                <span
                  class="investment-card__dropdown-label"
                  v-text="selectedPair.name"
                />
              </template>

              <template #item="{ option }">
                <div
                  class="p-10"
                  @click="localePush(`/exchange/${option.name}`)"
                  v-text="option.name"
                />
              </template>
            </exc-dropdown>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ExcButton, ExcDropdown } from '@/components/common'
import { mapState, mapGetters } from 'vuex'
import InvestmentPlanModel from '@/lib/data-models/investment/InvestmentPlanModel'

export default {
  name: 'InvestmentCard',
  components: {
    InvestmentCardInfoNumbers: () =>
      import(
        /* webpackMode: "eager" */ '@/components/staking-pool/card/InvestmentCardInfoNumbers.vue'
      ),
    ExcButton,
    ExcDropdown,
  },
  props: {
    investment: {
      type: InvestmentPlanModel,
      required: true,
    },
    dropdownOpenUp: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      loggedIn: state => state.auth.loggedIn,
    }),
    ...mapGetters({
      getCurrencyFullName: 'pairs/getCurrencyFullName',
    }),
    selectedPair () {
      return { name: this.$t('trade.btnBuy') }
    },
    cardLink () {
      // TODO fix routing to Staking pool item
      let link = ''
      if (this.investment.planCount === 1) {
        // directly to plan details
        link = {
          name: this.localePath('/c-freezer/plan'),
          params: { id: this.investment.redirectId },
        }
      } else {
        // link to items list
        link = {
          name: this.localePath('/c-freezer/item'),
          params: { ticker: this.investment.ticker },
        }
      }
      return this.localePath(
        `${link.name}/${link.params.id || link.params.ticker}`,
      )
    },
    status () {
      const status = this.investment.status

      const colors = {
        FINISHED: 'grey',
        ACTIVE: 'green',
        PENDING: 'color-09',
      }

      return {
        color: colors[status.type],
        text: this.$t(status.name[0]),
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.investment-card {
  display: flex;
  flex-direction: column;

  &__top {
    gap: toRem(20px);

    @include bp(l) {
      flex-direction: row;
      justify-content: space-between;
      gap: toRem(40px);
    }
  }

  &__title-with-status {
    @include bp(l) {
      width: max-content;
      max-width: toRem(207px);
      padding-top: toRem(10px);
    }
  }

  &__status-dot {
    height: toRem(6px);
    width: toRem(6px);
    border-radius: 100px;
  }

  &__hand-with-logo {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // padding: toRem(4px);

    // width: toRem(153);
    // width: toRem(100px);
    // height: toRem(100px);
    // background-image: url('@/assets/img/earn/item-hand.png');
    // background-size: toRem(372px) toRem(161px);
    // background-repeat: no-repeat;
    // background-position: toRem(-40px);
    // img {
    //   border: 8px solid color('main');
    //   border-radius: 100%;
    // }

    @include bp(l) {
      // padding: toRem(6px);
      // width: toRem(130px);
      // height: toRem(130px);
      // background-position: toRem(-8px);
    }
  }

  &__logo {
    border-radius: 100%;
    // max-width: toRem(100px);
    // max-height: toRem(100px);
    display: block;
    position: relative;
    width: toRem(100px);
    height: toRem(100px);
    // padding

    @include bp(l) {
      // max-width: toRem(132px);
      // max-height: toRem(132px);
      width: toRem(110px);
      height: toRem(110px);
    }
  }

  &__container {
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: toRem(24px);

    @include bp(l) {
      gap: toRem(12px);
    }
  }

  &__bottom {
    height: 100%;
  }

  &__buttons {
    width: 100%;
    align-self: center;
  }

  &__buttons-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: toRem(12px);

    @include bp(l) {
      display: flex;
      align-items: center;
    }
  }

  &__stating-button {
    flex: 1;

    @include bp(l) {
      max-width: min-content;
    }
  }

  &__dropdown-label {
    padding-left: toRem(18px);
  }

  &__dropdown {
    flex: 1;
  }

  ::v-deep {
    .exc-input-label-error-wrapper__content {
      margin-bottom: 0;
    }
  }
}
</style>
